import {FormGenAgent} from "./formgen";
import {ReactElement, useEffect, useState} from "react";
import {Button, CircularProgress, Typography, useTheme} from "@mui/material";
import {StyledBoxColumn} from "./StyledComponents";
import {PD_LG, PD_SM} from "./dimens";
import {Debouncer} from "./file_util";

const DEBOUNCER = new Debouncer();
export function FormGenTextAutoEnhance({agent, prompt, text, onResponse}: {
  agent: FormGenAgent,
  prompt: string,
  text: string,
  onResponse: (response: string) => void
}): ReactElement {
  const theme = useTheme();
  const [response, setResponse] = useState<string>();
  useEffect(() => {
    // For some reason, this useEffect is called twice.
    DEBOUNCER.run(() => {
      (async function () {
        new Debouncer().run(() => {

        })
        try {
          setResponse(await agent.chatResponse(`${prompt}\n${text}`));
        } catch (e) {
          setResponse(null);
        }
      })();
    });
  }, [prompt]);
  return <StyledBoxColumn style={{padding: PD_LG}}>
    <Typography variant={"caption"} style={{background: theme.palette.background.default, padding: PD_SM}}>
      {prompt}
    </Typography>
    {response !== undefined
      ? (response !== null
        ? <>
          <Typography>{response}</Typography>
          <Button variant={"contained"} onClick={() => onResponse(response)}>Apply</Button>
        </>
        : <Typography><i>Something went wrong</i></Typography>)
      : <CircularProgress/>}
  </StyledBoxColumn>;
}